
















































import {Component, Vue, Watch} from "vue-property-decorator";
import EnumSelector from "@/shared/components/EnumSelector/index.vue";
import {CommonStatus} from "@/enums/status";
import {assignValueToForm} from "@/shared/services/helper/utils";
import {SiteStore} from "@/modules/sites/store";
import debounce from "lodash/debounce";
import {SiteParams} from "@/modules/sites/params";
import CountrySelector from "@/modules/regions/CountrySelector/index.vue";
import ProvinceSelector from "@/modules/regions/ProvinceSelector/index.vue";
import DistrictSelector from "@/modules/regions/DistrictSelector/index.vue";
import PostOfficeSelector from "@/shared/components/PostOfficeSelector/index.vue";
import EmployeeSelector from "@/shared/components/EmployeeSelector/index.vue";
import PartnerSelector from "@/shared/components/PartnerSelector/index.vue";
import {mixins} from "vue-class-component";
import {CommonMixin} from "@/shared/services/mixin";
import WardSelector from "@/modules/regions/WardSelector/index.vue";
import {EmployeeType, PartnerType} from '@/enums/type';

@Component({
    name: "SiteSearch",
    components: {
        // WardSelector,
        PartnerSelector,
        EmployeeSelector,
        PostOfficeSelector, DistrictSelector, ProvinceSelector, CountrySelector, EnumSelector}
})
export default class extends mixins(CommonMixin) {
    CommonStatus = CommonStatus;
    EmployeeType = EmployeeType;
    PartnerType = PartnerType;
    form = new SiteParams();

    @Watch('form', { immediate: false, deep: true })
    onValuesChange(val: any) {
        this.handleChange(val);
    }

    handleChange = debounce(function (val) {
        SiteStore.updateSiteParams(val);
        SiteStore.listSite({ ...val, page: 1 })
    }, 500);
}
